import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { LanguageService } from '../i18n/language.service';
import { LoggingService } from '../utils/logging.service';
import { I18N } from './modal-dialog.i18n';

@Component({
    selector: 'common-form-modal-dialog-wrapper',
    template: `
        <div class="modalDialogContainer" (click)="onBackdropClick()">
            <div class="modalInfoBox {{additionalClass}}" aria-modal="true" role="dialog">
                <h2>{{header}}</h2>
                <div *ngIf="!disableClose" class="closeContainer">
                    <button (click)="onClose()" type="button" ibtn="shut"
                            ibtnUnboxed ibtnSmall title="{{i18n.close}}"></button>
                </div>
                <div class="modalBoxContent">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    `
})
/**
 * Eine verallgemeinerte Form von ModalDialogComponent, die es erlaubt, beliebigen Inhalt im modalen Dialog anzuzeigen.
 * Der Aufrufer ist selbst für das Ein- und Ausblenden der Komponente zuständig (zB mittels ngIf).
 */
export class ModalDialogWrapperComponent implements AfterViewInit, OnDestroy {

    /**
     * Bietet die Möglichkeit den Schließen-Button nicht zu rendern.
     */
    @Input() disableClose: boolean = false;

    @Input() header = ''; // Überschrift

    @Input() additionalClass: string = '';

    @Input() allowCloseOnBackdropClick: boolean = false;

    @Output() close = new EventEmitter();

    i18n: any;
    private destroyFn: () => void;
    private readonly languageSubscription: Subscription;

    constructor(private elementRef: ElementRef,
                private languageService: LanguageService,
                private log: LoggingService) {
        this.destroyFn = () => undefined;
        this.languageSubscription = languageService.registerForLanguageChanged(this, 'i18n', I18N);
    }

    @HostListener('document:keydown.escape', ['$event'])
    onEscapeHandler(_event: KeyboardEvent) {
        this.log.debug('[ModalDialogWrapperComponent]#onEscapeHandler: ESC gedrückt');
        this.onClose();
    }

    ngAfterViewInit() {
        const body = document.querySelector('body');

        if (!body.classList.contains('modalOpen')) {
            body.classList.add('modalOpen');
            this.destroyFn = () => {
                body.classList.remove('modalOpen');
            };
        }

        /**
         * Sucht für erstes Input und inh fokussiert
         */
        const inputToFocus = this.elementRef.nativeElement.querySelector('input');
        if (inputToFocus) {
            inputToFocus.focus();
        }
    }

    ngOnDestroy() {
        this.destroyFn();
        if (this.languageSubscription) this.languageSubscription.unsubscribe();
    }

    onClose() {
        if (!this.disableClose) {
            this.close.emit();
            this.log.debug(
                `[ModalDialogWrapperComponent]#onClose: Dialog '${this.header}' geschlossen!`
            );
        } else {
            this.log.debug(
                `[ModalDialogWrapperComponent]#onClose: Schließen des Dialogs '${this.header}' ist gedisabeld!`
            );
        }
    }

    onBackdropClick() {
        if (this.allowCloseOnBackdropClick) {
            this.log.debug(
                `[ModalDialogWrapperComponent]#onBackdropClick: Backdrop von Dialog '${this.header}' geklickt, `
                + `versuche Dialog zu schließen!`
            );
            this.onClose();
        }
    }
}
